import LoyaltyRankProgressBig from "components/organisms/LoyaltyRankProgressBig";
import { useGetProgressLoyalty } from "queries/useGetProgressLoyalty";
import { useGetLoyaltyUser } from "queries/useGetLoyaltyUser";
import { getCurrentRank } from "utils/loyalty";

const LoyaltyRankProgressBigContainer = () => {
  const { data: progressData } = useGetProgressLoyalty();
  const { data: loyaltyData } = useGetLoyaltyUser();
  const progressUser = progressData?.data?.data;
  const loyalty = loyaltyData?.data?.data;
  const { currentRank, nextRank } = getCurrentRank(
    loyalty,
    progressUser?.experience,
  );
  const userExperience = progressUser?.experience || 0;

  return currentRank ? (
    <LoyaltyRankProgressBig
      rank={currentRank}
      nextRank={nextRank}
      userExperience={userExperience}
    />
  ) : null;
};

export default LoyaltyRankProgressBigContainer;
